// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"8fe61424","659":"936d9d1e","787":"921a83d9","929":"1cd5cbac","934":"9e3cf86d","947":"adfc455a","962":"70273202","989":"99ef1c1f"}[chunkId] + ".chunk.js";
};